import { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { withRouter, Link } from 'react-router-dom/cjs/react-router-dom.min'
import { Container, Input, Row, Col, Button } from 'reactstrap'
import brandit_rails from '../../api/brandit_rails'
import { isValidEmail } from '../../util/utils'
import { setErrors } from './checkoutFunctions'

const GuestCheckoutPanel = props => {
  const [emailValid, setEmailValid] = useState(false)
  const [touched, setTouched] = useState(false)
  const [userExistsOnPortal, setUserExistsOnPortal] = useState(false)

  const dispatch = useDispatch()

  const handleChangeContactEmail = e => {
    setTouched(true) // Mark input as touched
    const email = e.target.value

    const formData = new FormData()
    formData.append('email', email)
    brandit_rails.post('/users/check_guest_email', formData).then(response => {
      setUserExistsOnPortal(response.data.exists)
    })

    const isValid = isValidEmail(email)

    if (!isValid) {
      setEmailValid(false)
      props.setErrors({ contactEmail: true })
      return
    } else {
      setEmailValid(true)
      props.setErrors({ contactEmail: false })
    }

    // dispatch action to save contact email to checkout reducer
    dispatch({ type: 'SET_CONTACT_EMAIL', payload: email })
  }

  const goToLogin = () => {
    props.history.push(props.portal.custom_login_url)
  }

  if (props.currentUser.id) return null

  return (
    <div className="box-shadow white-background m-0">
      <div className="ckout-header">
        <h5 className="m-0">Checkout</h5>
      </div>
      <Container className="mb-4">
        <Row className="align-items-start p-3">
          <Col xs="5">
            <p>
              Prefer guest checkout? <br />
              Simply enter your email for confirmation and tracking.
            </p>
            <Input
              placeholder="Contact Email"
              name="contact_email"
              type="email"
              onBlur={handleChangeContactEmail}
              className={!emailValid && touched ? 'is-invalid' : ''}
            />
            {!emailValid && touched && <div className="text-danger small mt-1">Please enter a valid email.</div>}
            {userExistsOnPortal && (
              <div className="text-success small mt-1">
                We found an account associated with this email.{' '}
                <Link to={props.portal.custom_login_url}>Click here to sign in</Link> and save this order to your
                account.
              </div>
            )}
          </Col>
          <Col xs="2" className="text-center text-muted align-self-center">
            <small>- or -</small>
          </Col>
          <Col xs="5">
            <p>Sign in to use your saved addresses & credits, and to store this order in your account.</p>
            <Button className="w-100" color="secondary" onClick={goToLogin}>
              Sign In
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    portal: state.portal,
    currentUser: state.currentUser
  }
}

export default connect(mapStateToProps, { setErrors })(withRouter(GuestCheckoutPanel))
